import React from 'react'
import BreadCrumComponent from '../BreadCrumComponent';
import ModalLogs from './ModalLogs';
import img_success from '../../../assets/images/ilustraciones/img-success.svg';
import img_error from '../../../assets/images/ilustraciones/img-error.svg'

class AvisoImportLote extends React.Component {

    constructor(props) {
        super(props);

        let data = props.location.state;

        const { resultado } = props.match.params;

        /*
        if (!data) {
            const savedData = localStorage.getItem('resultadoImportacionLote');
            if (savedData) {
                data = JSON.parse(savedData);
            }
        }
        */

        this.state = {
            resultado,
            idLote: data?.idLote,
            totalRecibos: data?.totalRecibos,
            totalCorrectos: data?.totalCorrectos,
            errors: data?.errors,
            modalError: false
        };

        this.modalRef = React.createRef();
    }

    limpiarStorage() {
        localStorage.removeItem('resultadoImportacionLote');
    }

    handleContinuar = () => {
        //this.limpiarStorage();
        this.props.history.push('/lote/recibos/nuevo/' + this.state.idLote);
    }

    handleLoHareLuego = () => {
        //this.limpiarStorage();
        this.props.history.push('/bandeja/pendientes');
    }

    handleVolverAtras = () => {
        this.props.history.push('/lotes/generar');
    }

    handleMostrarErrores = (valor) => {
        this.setState({
            modalError: valor
        })
    }

    renderResultError = () => {
        return (
            <div className="container-flex container-md">

                <div className="col">
                    <h1 className="section__subtitle-sm"> Ha ocurrido un error </h1>
                    <div className="card card-flex">
                        <h3 className="card-title"> Aquí tienes un resumen</h3>

                        <div className="grid">
                            <div className="card-info">
                                <span className="label"> Total de Recibos </span>
                                <span className="txt"> {this.state.totalRecibos} </span>
                            </div>
                            <div className="card-info">
                                <span className="label"> Importaciones correctas </span>
                                <span className="txt"> {this.state.totalCorrectos} </span>
                            </div>
                        </div>

                        <div className="card-actions">
                            <button onClick={this.handleMostrarErrores} className="btn-medium btn-primary-outline open-dialog" data-dialog="modal-logs">
                                Ver Log de Errores
                            </button>
                        </div>
                    </div>

                    <div className="actions">
                        <button onClick={this.handleVolverAtras} className="btn-medium btn-primary">Volver a generar lote</button>
                    </div>
                </div>

                <div className="col">
                    <div className="illustration">
                        <img src={img_error} className="img-fluid" alt="accion_error" />
                    </div>
                </div>
                <ModalLogs
                    ref={(ref) => (this.modalRef = ref)}
                    abierto={this.state.modalError}
                    onClose={() => this.handleMostrarErrores(false)}
                    errors={this.state.errors}
                />
            </div>
        );
    }

    renderResultExito = () => {
        return (
            <div className="container-flex container-md">

                <div className="col">
                    <h1 className="section__subtitle-sm"> ¡La Importación finalizó con éxito! </h1>
                    <div className="card">
                        <h3 className="card-title"> Aquí tienes un resumen</h3>
                        <div className="card-info">
                            <span className="label"> Total de Recibos </span>
                            <span className="txt"> {this.state.totalRecibos} </span>
                        </div>
                        <div className="card-info">
                            <span className="label"> Importaciones correctas </span>
                            <span className="txt"> {this.state.totalCorrectos} </span>
                        </div>
                    </div>
                    <p className="section__description"> Para finalizar, debes firmar el documento, ¿Deseas proceder a la firma y envío del lote? </p>
                    <div className="actions">
                        <button onClick={this.handleContinuar} className="btn-medium btn-primary">Continuar Firmando</button>
                        <button onClick={this.handleLoHareLuego} className="btn-medium "> Lo haré luego </button>
                    </div>
                </div>

                <div className="col">
                    <div className="illustration">
                        <img src={img_success} className="img-fluid" alt="accion_success" />
                    </div>
                </div>

            </div>
        );
    }
    render() {

        return (
            <div className="template-base">
                <header className="component-header">
                    <div className="page-container">
                        <BreadCrumComponent
                            backUrl="/bandeja/pendientes"
                            breadcrumbs={
                                [
                                    { label: 'Importar Lote desde Zip', path: '' },
                                    { label: 'Resultados de la importacion', path: '' },
                                ]
                            }
                        />
                    </div>
                </header>
                <div className="wrapperContent">
                    <div className="component-advice">
                        <div className="page-container">
                            {this.state.resultado == 'error'
                                ? this.renderResultError()
                                : this.renderResultExito()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AvisoImportLote